import { action } from "@storybook/addon-actions";
import { ComponentMeta, ComponentStory } from "@storybook/react";
import { Circle } from "lucide-react";
import React from "react";
import { MemoryRouter } from "react-router-dom";
import Flex from "../Flex";
import { InternalLinkButton, InternalLinkButtonProps } from "./InternalLinkButton";

const commonArgs: InternalLinkButtonProps = {
    to: "/",
    trackName: "button",
    loading: false,
    title: "Button CTA",
    onClick: action("clicked")
};

export default {
    title: "common/Buttons/InternalLinkButton",
    component: InternalLinkButton,
    args: commonArgs
} as ComponentMeta<typeof InternalLinkButton>;

const Template: ComponentStory<typeof InternalLinkButton> = args => {
    return (
        <MemoryRouter initialEntries={["/"]}>
            <Flex spacing={1} alignItems="center">
                <InternalLinkButton {...args} size="lg" />
                <InternalLinkButton {...args} size="md" />
                <InternalLinkButton {...args} size="sm" />
            </Flex>
        </MemoryRouter>
    );
};

export const Text = Template.bind({});

export const TextIcon = Template.bind({});
TextIcon.args = {
    icon: <Circle />
};

export const TextLoading = Template.bind({});
TextLoading.args = {
    loading: true
};

export const DestructiveText = Template.bind({});
DestructiveText.args = {
    destructive: true
};

export const DestructiveTextLoading = Template.bind({});
DestructiveTextLoading.args = {
    ...DestructiveText.args,
    loading: true
};

export const WithTooltip = Template.bind({});
WithTooltip.args = {
    tooltip: "Tooltip text"
};

export const Variants: ComponentStory<typeof InternalLinkButton> = args => {
    return (
        <MemoryRouter initialEntries={["/"]}>
            <Flex spacing={1} alignItems="center">
                <InternalLinkButton {...args} variant="primary" />
                <InternalLinkButton {...args} variant="secondary" />
                <InternalLinkButton {...args} variant="tertiary" />
            </Flex>
        </MemoryRouter>
    );
};
